// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"beh_a bhe_bk bhe_bl bhe_bo","SwipeLeftToClose--animating":"beh_b"};